import { useTranslation } from "react-i18next"
import { useLazyLoadQuery } from "react-relay"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { chPatientByIdQuery } from "@/modules/patients/services/ch/__generated__/chPatientByIdQuery.graphql"
import {
  ch_PatientByIdQuery,
  ChInsuree,
  ChInsurees,
  ChMedgateServiceInfo,
} from "@/modules/patients/services/ch/chPatientByIdQuery"
import { dePatientByIdQuery } from "@/modules/patients/services/de/__generated__/dePatientByIdQuery.graphql"
import {
  de_PatientByIdQuery,
  DeInsuree,
  DeInsurees,
  DeMedgateServiceInfo,
} from "@/modules/patients/services/de/dePatientByIdQuery"

function usePatientByIdQuery(patientId: string, countryCode: Country, appointmentId: string | null) {
  const { i18n } = useTranslation()
  const query = countryCode === "CH" ? ch_PatientByIdQuery : de_PatientByIdQuery
  const data = useLazyLoadQuery<dePatientByIdQuery | chPatientByIdQuery>(query, {
    patientId,
    appointmentId,
    language: i18n.language,
  })
  return [data]
}

type Insurees = DeInsurees | ChInsurees

type Insuree = DeInsuree | ChInsuree

type MedgateServiceInfo = DeMedgateServiceInfo | ChMedgateServiceInfo

export { usePatientByIdQuery, type Insuree, type Insurees, type MedgateServiceInfo }
